import { Button } from 'components';
import { theme } from 'lib';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  background-color: #000;
  height: 600px;
  position: relative;

  @media (max-width: 1024px) {
    height: 560px;
    width: 100vw;
    display: flex;
    flex-direction: column;
  }
`;

const ContentArea = styled.div`
  display: flex;
  flex-direction: row;
  width: 1140px;
  height: 100%;
  position: relative;
  align-self: center;

  @media (max-width: 1024px) {
    width: 100%;
  }
`;

const DateTag = styled.div`
  width: 268px;
  height: 282px;
  background-color: ${theme.GREEN};
  position: absolute;
  right: 32px;
  display: flex;
  flex-direction: column;
  align-items: center;
  z-index: 1;

  .date-text {
    font-family: CeraPro;
    font-size: 32px;
    font-weight: 500;
    margin-top: 21px;
  }

  .location-text {
    font-family: CeraPro;
    font-size: 16px;
    font-weight: 500;
    margin-top: 10px;
  }

  @media (max-width: 1024px) {
    height: 134px;
    width: 181px;
    margin: 0 auto;
    right: 0;
    position: inherit;

    .date-text {
      font-size: 16px;
      font-weight: 500;
      line-height: 22px;
      margin-top: 6px;
    }

    .location-text {
      font-size: 14px;
      font-weight: 400;
      line-height: 18px;
      margin-top: 0;
    }
  }
`;

const ImageBackground = styled.div`
  background: url(${(props) => props.src});
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  width: 121px;
  height: 94px;
  margin-top: 48px;
  z-index: 2;

  @media (max-width: 1024px) {
    background-size: contain;
    width: 70px;
    height: 54px;
    margin-top: 16px;
  }
`;

const BannerImg = styled.div`
  width: 1171px;
  height: 542px;
  position: absolute;
  top: 120px;
  right: -80px;
  background: url(${(props) => props.src});
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;

  @media (max-width: 1024px) {
    top: 0;
    right: 0;
    height: 560px;
    width: 100vw;
  }
`;

const BannerTextWrapper = styled.div`
  position: absolute;
  top: 46px;
  left: -108px;

  @media (max-width: 1024px) {
    top: 180px;
    left: 16px;
  }
`;

const BannerParagraph = styled.p`
  color: #fff;
  font-family: CeraStencil;
  font-size: 120px;
  font-weight: 700;
  line-height: 90px;
  width: 868px;
  text-indent: 170px;

  @media (min-width: 1024px) {
    br {
      display: none;
    }
  }

  @media (max-width: 1024px) {
    font-size: 52px;
    line-height: 41px;
    text-indent: 58px;
    width: 288px;
  }
`;

const RegisterButtonWrapper = styled.div`
  position: absolute;
  top: 381px;
  left: 396px;

  button {
    width: 268px !important;
    p {
      font-size: 22px;
      line-height: 28px;
    }
  }

  @media (max-width: 1024px) {
    top: 420px;
    width: 100%;
    left: 0;
    display: flex;
    justify-content: center;

    button {
      width: 288px !important;
      height: 50px !important;
      p {
        font-size: 18px;
        line-height: 22px;
      }
    }
  }
`;

const Banner = (props) => {
  const { t } = useTranslation();
  return (
    <Wrapper>
      <ContentArea>
        <DateTag>
          <ImageBackground src={require('assets/images/tampa-bay-logo.png')} />

          <div className="date-text">{t('website.date')}</div>

          <div className="location-text">{t('website.location')}</div>
        </DateTag>

        <BannerImg src={require('assets/images/basketball-event.png')}>
          <BannerTextWrapper>
            <BannerParagraph>
              {t('website.dontMiss')}
              {t('website.outOn')}
              <br /> {t('website.your')}
              {t('website.timeToShine')}
            </BannerParagraph>
          </BannerTextWrapper>

          <RegisterButtonWrapper>
            <Button text={t('website.registerForCombine')} website />
          </RegisterButtonWrapper>
        </BannerImg>
      </ContentArea>
    </Wrapper>
  );
};

export default Banner;
